import MenuItem from "./../../../core/components/menu/MenuItem";
import i18n from '../../../shared/i18n'
import Settlements from "./Settlements";

let routes = [{
  path: 'settlements',
  name: 'settlements',
  component: Settlements,
  meta: {
    requiresAuth: true
  }
}];

export default {
  menuItem: new MenuItem('/settlements', i18n.t('Settlements'), 40, 'file-invoice', [], 'view_settlement'),
  routes: routes
}
